import { DetailsType, FormData, Attachment } from 'types/application';
import {
    attachmentActions,
    attachmentPayloadSetting,
    attachmentRetrieve,
    formDeleteApplication,
    payloadDeleteApplication
} from '../helpers';
import { SECT_ORGANISATION, SECT_PUB_DETAILS } from 'common/application.const';

import { decryptId } from 'common/decrypt';

type Props = {
    myInfoContent: any;
    uen?: string;
};

const autoFillData = async ({ myInfoContent, uen }: Props) => {
    const person = myInfoContent?.corppass || {};
    const entity = myInfoContent?.['basic-profile'] || {};
    const address = myInfoContent?.address || {};

    const decryptedUEN = await decryptId(uen || '', 'decrypt');

    const orgForm = {
        id: 'organisation',
        formID: 'organisation',
        hasError: true,
        values: {
            [`${SECT_ORGANISATION}-name`]: person?.['corppass-user']?.name?.value,
            // [`${SECT_ORGANISATION}-nationality`]: person?.nationality?.code,
            [`${SECT_ORGANISATION}-uen`]: decryptedUEN,
            [`${SECT_ORGANISATION}-company-name`]: entity['entity-name']?.value,
            [`${SECT_ORGANISATION}-mobile-no-country-code`]: '65',
            [`${SECT_ORGANISATION}-mobile-no-main`]: person?.mobile?.value,
            [`${SECT_ORGANISATION}-office-no-country-code`]: '65',
            [`${SECT_ORGANISATION}-office-no-main`]: '',
            [`${SECT_ORGANISATION}-email`]: person?.email?.value,
            [`${SECT_ORGANISATION}-address-type`]: address.addresstype || 'SG',
            [`${SECT_ORGANISATION}-postal`]: address.postal?.value,
            [`${SECT_ORGANISATION}-block-house`]: address.block?.value,
            [`${SECT_ORGANISATION}-street`]: address.street?.value,
            [`${SECT_ORGANISATION}-floor`]: address.floor?.value,
            [`${SECT_ORGANISATION}-unit`]: address.unit?.value,
            [`${SECT_ORGANISATION}-building`]: address.building?.value
        }
    };

    return orgForm;
};

export const formatRetrieve = async (content: any, action?: string) => {
    if (action === 'application-delete') return formDeleteApplication;
    const orgValues = content.Organisation || {};
    const orgContact = orgValues.Contact || {};
    const orgAddress = orgValues.Address && orgValues.Address.length > 0 ? orgValues.Address[0]?.MailingAddress || {} : {};

    const orgForm = {
        id: 'organisation',
        formID: 'organisation',
        hasError: true,
        values: {
            // [`${SECT_APPLICANT}-id-type`]: orgValues.IDType,
            // [`${SECT_APPLICANT}-idno`]: orgValues.IDNo,
            // [`${SECT_APPLICANT}-salutaion`]: orgValues.Salutation,
            [`${SECT_ORGANISATION}-name`]: orgValues.Person?.pyFullName,
            // [`${SECT_APPLICANT}-bday`]: formatDate(orgValues.DateOfBirth) ,
            [`${SECT_ORGANISATION}-nationality`]: orgValues.Nationality,
            [`${SECT_ORGANISATION}-uen`]: orgValues.UEN,
            [`${SECT_ORGANISATION}-company-name`]: orgValues.CompanyName,
            [`${SECT_ORGANISATION}-mobile-no-country-code`]: orgContact.MobileNoCountryCode || '65',
            [`${SECT_ORGANISATION}-mobile-no-main`]: orgContact.MobileNo,
            [`${SECT_ORGANISATION}-office-no-country-code`]: orgContact.OfficeNoCountryCode || '65',
            [`${SECT_ORGANISATION}-office-no-main`]: orgContact.OfficeNo,
            [`${SECT_ORGANISATION}-email`]: orgContact.EmailAddress,
            [`${SECT_ORGANISATION}-address-type`]: orgAddress.AddressType || 'SG',
            [`${SECT_ORGANISATION}-postal`]: orgAddress.PostalCode,
            [`${SECT_ORGANISATION}-block-house`]: orgAddress.BlockNumber,
            [`${SECT_ORGANISATION}-street`]: orgAddress.StreetName,
            [`${SECT_ORGANISATION}-floor`]: orgAddress.FloorNumber,
            [`${SECT_ORGANISATION}-unit`]: orgAddress.UnitNumber,
            [`${SECT_ORGANISATION}-building`]: orgAddress.BuildingName
        }
    };

    const pubForms = await Promise.all(
        content?.PublicationList?.map(async (pub: any, index: number) => ({
            id: `publication-${index + 1}`,
            formID: 'publication',
            hasError: true,
            values: {
                [`${SECT_PUB_DETAILS}-publication-type`]: pub.Type,
                [`${SECT_PUB_DETAILS}-item-type`]: pub.ItemType,
                [`${SECT_PUB_DETAILS}-other-item-type`]: pub.OtherItemType,
                [`${SECT_PUB_DETAILS}-publication-title`]: pub.Title,
                [`${SECT_PUB_DETAILS}-romanized-title`]: pub.RomanizedTitle,
                [`${SECT_PUB_DETAILS}-isbn-no`]: pub.ISBNNo,
                [`${SECT_PUB_DETAILS}-issn-no`]: pub.ISSNNo,
                [`${SECT_PUB_DETAILS}-language`]: pub.Language,
                [`${SECT_PUB_DETAILS}-language-description`]: pub.LanguageDescription,
                [`${SECT_PUB_DETAILS}-issue-no`]: pub.IssueNo,
                [`${SECT_PUB_DETAILS}-author`]: pub.Author,
                [`${SECT_PUB_DETAILS}-artiste`]: pub.Artiste,
                [`${SECT_PUB_DETAILS}-publisher`]: pub.Publisher,
                [`${SECT_PUB_DETAILS}-volume-no`]: pub.VolumeNo,
                [`${SECT_PUB_DETAILS}-country-published`]: pub.Country,
                [`${SECT_PUB_DETAILS}-other-country`]: '',
                [`${SECT_PUB_DETAILS}-no-of-copies-imported`]: pub.ImportedCopies,
                [`${SECT_PUB_DETAILS}-reason-submission`]: pub.SubmissionReason,
                [`${SECT_PUB_DETAILS}-attachments`]: attachmentRetrieve(pub.AttachmentList),
                [`${SECT_PUB_DETAILS}-physical-copy`]: pub.PhysicalCopy || 'No',
                [`${SECT_PUB_DETAILS}-publication-id`]: pub.caseid,
                [`${SECT_PUB_DETAILS}-concatenated-title`]: pub.ConcatenatedTitle || '',
                [`${SECT_PUB_DETAILS}-link-to-attachments`]: pub.LinkToAttachments
            }
        }))
    );

    return [orgForm, ...(pubForms || [])];
};

export const formatSave = async (details: DetailsType, caseTypeID: string, pageInstructions: any[] = [], action?: string) => {
    if (action === 'application-delete') return payloadDeleteApplication;
    const organisation = details.forms.find((form: FormData) => form.id === 'organisation')?.values || {};
    const publicationDetails = details.forms.filter((form: FormData) => form.formID === 'publication');

    // let filesToUpload: Attachment[] = [];
    let pageInstructionsForDelete: any[] = [];

    await Promise.all(
        publicationDetails.map(async (publication: FormData, pubInx: number) => {
            const publicationValues = publication?.values || {};
            const attachments = (publicationValues[`${SECT_PUB_DETAILS}-attachments`] as Attachment[]) || [];
            const attachmentsAction = await attachmentActions(attachments, `PublicationList(${pubInx + 1}).AttachmentList`, caseTypeID);

            // filesToUpload = [...filesToUpload, ...attachmentsAction.toUpload];
            pageInstructionsForDelete = [...pageInstructionsForDelete, ...attachmentsAction.pageInstructions];
        })
    );

    // const filesToAttach = await requestUpload(filesToUpload, 'SupportingDocuments');
    // if (filesToAttach.length > 0) {
    //     await requestAttach(filesToAttach, caseTypeID);
    // }
    // const uploadedFiles = caseTypeID ? await requestAttachmentList(caseTypeID) : [];
    return {
        caseTypeID: 'IMDA-IRIS-Work-Publication',
        content: {
            UEN: organisation[`${SECT_ORGANISATION}-uen`],
            DraftTitle: publicationDetails
                .map((pub: FormData) => (pub.values ? pub.values[`${SECT_PUB_DETAILS}-publication-title`] : ''))
                .join(', '),
            Organisation: {
                CompanyName: organisation[`${SECT_ORGANISATION}-company-name`],
                pxObjClass: 'IMDA-Data-Organisation',
                UEN: organisation[`${SECT_ORGANISATION}-uen`],
                Address: [
                    {
                        pxObjClass: 'IMDA-Data-Address',
                        MailingAddress: {
                            BlockNumber: organisation?.[`${SECT_ORGANISATION}-block-house`] ?? '',
                            BuildingName: organisation?.[`${SECT_ORGANISATION}-building`] ?? '',
                            FloorNumber: organisation?.[`${SECT_ORGANISATION}-floor`] ?? '',
                            PostalCode: organisation?.[`${SECT_ORGANISATION}-postal`] ?? '',
                            pxObjClass: 'IMDA-Data-Address',
                            StreetName: organisation?.[`${SECT_ORGANISATION}-street`] ?? '',
                            UnitNumber: organisation?.[`${SECT_ORGANISATION}-unit`] ?? ''
                        }
                    }
                ],
                Contact: {
                    EmailAddress: organisation?.[`${SECT_ORGANISATION}-email`] ?? '',
                    MobileNo: organisation?.[`${SECT_ORGANISATION}-mobile-no-main`] ?? '',
                    MobileNoCountryCode: organisation?.[`${SECT_ORGANISATION}-mobile-no-country-code`] ?? '',
                    OfficeNo: organisation?.[`${SECT_ORGANISATION}-office-no-main`] ?? '',
                    OfficeNoCountryCode: organisation?.[`${SECT_ORGANISATION}-office-no-country-code`] ?? '',
                    pxObjClass: 'IMDA-Data-Contact'
                },
                Person: {
                    pxObjClass: 'IMDA-Data-Person',
                    pyFullName: organisation?.[`${SECT_ORGANISATION}-name`] ?? ''
                }
            },
            PublicationList: publicationDetails.map((publication: FormData) => {
                const publicationValues = publication?.values || {};
                const pubDetailsPayload = {
                    Artiste: publicationValues[`${SECT_PUB_DETAILS}-artiste`],
                    Author: publicationValues[`${SECT_PUB_DETAILS}-author`],
                    Country: publicationValues[`${SECT_PUB_DETAILS}-country-published`],
                    ImportedCopies: Number(publicationValues[`${SECT_PUB_DETAILS}-no-of-copies-imported`] ?? 0),
                    ISBNNo: publicationValues[`${SECT_PUB_DETAILS}-isbn-no`],
                    ISSNNo: publicationValues[`${SECT_PUB_DETAILS}-issn-no`],
                    IssueNo: publicationValues[`${SECT_PUB_DETAILS}-issue-no`],
                    Language: publicationValues[`${SECT_PUB_DETAILS}-language`],
                    LanguageDescription: publicationValues[`${SECT_PUB_DETAILS}-language-description`],
                    PhysicalCopy: publicationValues[`${SECT_PUB_DETAILS}-physical-copy`] || 'No',
                    Publisher: publicationValues[`${SECT_PUB_DETAILS}-publisher`],
                    VolumeNo: publicationValues[`${SECT_PUB_DETAILS}-volume-no`],
                    pxObjClass: 'IMDA-IRIS-Data-Publication',
                    RomanizedTitle: publicationValues[`${SECT_PUB_DETAILS}-romanized-title`],
                    SubmissionReason: publicationValues[`${SECT_PUB_DETAILS}-reason-submission`],
                    Title: publicationValues[`${SECT_PUB_DETAILS}-publication-title`],
                    Type: publicationValues[`${SECT_PUB_DETAILS}-publication-type`],
                    ItemType: publicationValues[`${SECT_PUB_DETAILS}-item-type`],
                    LinkToAttachments: publicationValues[`${SECT_PUB_DETAILS}-link-to-attachments`],
                    AttachmentList: attachmentPayloadSetting((publicationValues[`${SECT_PUB_DETAILS}-attachments`] || []) as Attachment[])
                };
                return pubDetailsPayload;
            })
        },
        ...(pageInstructionsForDelete.length > 0 && { pageInstructions: pageInstructionsForDelete }),
        ...(pageInstructions?.length > 0 && { pageInstructions })
    };
};

export const emptySet = {
    [`${SECT_PUB_DETAILS}-publication-type`]: '',
    [`${SECT_PUB_DETAILS}-item-type`]: '',
    [`${SECT_PUB_DETAILS}-other-item-type`]: '',
    [`${SECT_PUB_DETAILS}-publication-title`]: '',
    [`${SECT_PUB_DETAILS}-romanized-title`]: '',
    [`${SECT_PUB_DETAILS}-isbn-no`]: '',
    [`${SECT_PUB_DETAILS}-issn-no`]: '',
    [`${SECT_PUB_DETAILS}-language`]: '',
    [`${SECT_PUB_DETAILS}-language-description`]: '',
    [`${SECT_PUB_DETAILS}-issue-no`]: '',
    [`${SECT_PUB_DETAILS}-author`]: '',
    [`${SECT_PUB_DETAILS}-artiste`]: '',
    [`${SECT_PUB_DETAILS}-publisher`]: '',
    [`${SECT_PUB_DETAILS}-country-published`]: '',
    [`${SECT_PUB_DETAILS}-other-country`]: '',
    [`${SECT_PUB_DETAILS}-no-of-copies-imported`]: '',
    [`${SECT_PUB_DETAILS}-reason-submission`]: '',
    [`${SECT_PUB_DETAILS}-attachments`]: [],
    [`${SECT_PUB_DETAILS}-physical-copy`]: 'No',
    [`${SECT_PUB_DETAILS}-publication-id`]: '',
    [`${SECT_PUB_DETAILS}-link-to-attachments`]: ''
};

const pubPayload = {
    autoFillData,
    formatRetrieve,
    formatSave,
    emptySet
};

export default pubPayload;
